import { render, staticRenderFns } from "./uokoFinManFin.vue?vue&type=template&id=0bbe53c2&scoped=true"
import script from "./uokoFinManFin.vue?vue&type=script&lang=js"
export * from "./uokoFinManFin.vue?vue&type=script&lang=js"
import style0 from "./uokoFinManFin.vue?vue&type=style&index=0&id=0bbe53c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe53c2",
  null
  
)

export default component.exports